import { render, staticRenderFns } from "./AirPollutionNetwork.vue?vue&type=template&id=625020f7&"
import script from "./AirPollutionNetwork.vue?vue&type=script&lang=js&"
export * from "./AirPollutionNetwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports